import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Box, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../constants/cypressIds';
import colors from '../../../../styles/theme/foundation/colors';
import RequirementTemplateBlueprintType from '../../../../types/RequirementTemplateBlueprintType';

import RequirementMenuButton from './RequirementMenuButton';

const RequirementPropertyTypeMenu = ({ children, layerStyle, hasMore, fetchNext, blueprint, cypressIdFunction }) => (
  <Flex
    alignItems="flex-start"
    height="100%"
    justifyContent="space-between"
    minHeight="300px"
    overflow="hidden"
    w="100%"
  >
    <Box
      height="auto"
      layerStyle={layerStyle}
      marginTop={0}
      maxHeight="100%"
      overflowY="auto"
      position="relative"
      width="100%"
    >
      <InfiniteScroll
        dataLength={children.length}
        hasMore={hasMore}
        height={children.length < 10 ? 'auto' : '525px'}
        loader={<Text color={colors.greyScale['600']} textStyle="bodySm">Loading...</Text>}
        next={() => fetchNext()}
      >
        <Box>
          {children.map((child, idx) => {
            if (!child.props.title && !child.props.description) {
              const CustomTab = child.props.component;
              return <CustomTab />;
            }

            return (
              <RequirementMenuButton
                blueprint={blueprint}
                cypressId={cypressIdFunction(child.props?.id)}
                description={child.props?.description}
                id={child.props?.id}
                idx={idx}
                isFavorite={child.props.isFavorite}
                key={child.props.id}
                leftIcon={child.props.icon}
                subMenu={child.props.subMenu}
                title={child.props.title}
                onFavoriteButtonCLick={child.props.onFavoriteButtonCLick}
                onMenuButtonClick={child.props.onClick}
              />
            );
          })}
        </Box>
      </InfiniteScroll>
    </Box>
  </Flex>
);

const RequirementMenuItem = ({ children }) => <>{children}</>;

RequirementPropertyTypeMenu.defaultProps = { layerStyle: 'container' };

RequirementPropertyTypeMenu.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape({
    props: PropTypes.shape({
      description: PropTypes.string,
      title: PropTypes.string,
      icon: PropTypes.func
    })
  })),
  layerStyle: PropTypes.string,
  hasMore: PropTypes.bool,
  fetchNext: PropTypes.func,
  blueprint: RequirementTemplateBlueprintType,
  cypressIdFunction: PropTypes.func
};

RequirementMenuItem.propTypes = { children: PropTypes.element };

export { RequirementMenuItem, RequirementPropertyTypeMenu };
